import React, { useState } from 'react';
import LoginForm from './login-form';
import ForgotPassword from './modal/ForgotPasswordModal';
import LayoutLogin from './layout/LayoutLogin';


const Login = () => {
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState<boolean>(false)
    const onShowHideForgotPassword = () => {
        setShowForgotPasswordModal(!showForgotPasswordModal)
    }

    return (
        <LayoutLogin>
            <div className='min-w-full h-[100%] flex flex-col justify-between items-start'>
                {/* <NavLink to='/'> */}
                {/* Logo here */}
                {/* <img className='max-w-[290px]' alt='for the earth' src='/logo/logo.svg' /> */}
                {/* </NavLink> */}
                <img src={'/assets/admin/header-icon.svg'} className='object-contain h-[45px] mb-5 ml-5' />
                <div className='m-auto'>

                    <h1 className='font-dm_sansbold text-[#101010] text-4xl text-left'>Sign in</h1>
                    <p className='mb-5'>Into your hotel dashboard</p>
                    <LoginForm
                        onShowHideForgotPassword={onShowHideForgotPassword} />
                    {/* <div className='my-4 flex flex-row items-center justify-center'>
                        <div className='min-w-[40%] h-[0.7px] m-1 inline-block bg-black'></div>
                        <div className='inline-block mx-2 font-semibold'>Or</div>
                        <div className='min-w-[40%] h-[0.7px] m-1 inline-block bg-black'></div>
                    </div> */}
                    {/* <div className='my-3 flex flex-row justify-center items-center'>
                        <p>I don’t have an account. </p>
                        <Button
                            className='text-primary-default !pl-0 !ml-1 underline font-medium'
                            label='Apply Now'
                            dataQa={'create-acc-link'}
                            onClickButton={() => navigate('/apply')}
                        />
                    </div> */}
                </div>
                <ForgotPassword
                    openForgotModal={showForgotPasswordModal}
                    handleCloseForgotModal={onShowHideForgotPassword}
                />
                <div className='flex flex-row justify-between min-w-full'>
                    <div className='flex items-center '>
                        <div className='cursor-pointer hover:opacity-80'>Terms</div>
                        <span className='px-1 text-black '>•</span>
                        <div className='cursor-pointer hover:opacity-80'>Privacy Policy</div>
                    </div>
                    <div>
                        <p>&copy; All rights reserved.</p>
                    </div>
                </div>
            </div>
        </LayoutLogin>
    )
}

export default Login;